type Organization = {
  name: string;
};

export const isVithas = (organization: Organization) =>
  organization?.name?.toLowerCase() === 'vithas';
